import { LinearProgress, withStyles } from '@material-ui/core'
import { GRAY_COLORS, PRIMARY_COLORS } from '../colors.constant'

export const AsterProgress = withStyles(theme => ({
  root: {
    height: 8,
    borderRadius: 4
  },
  colorPrimary: {
    backgroundColor: GRAY_COLORS[200]
  },
  bar: {
    borderRadius: 4,
    backgroundColor: PRIMARY_COLORS[700]
  }
}))(LinearProgress)
